module.exports = __webpack_public_path__ + "static/media/avast-vince-fastest.95f28681.jpg";